import { AnyAction, combineReducers } from 'redux';
import { FetchStatus } from '../appState';
import { Popup } from '../../hexagon/models/PopupModel';

export const data = (state: Popup = {} as Popup, action: AnyAction) => {
    if (action.type === 'popup/popupReceived') {
        return action.payload.popup;
    }
    return state;
};

export const status = (state: FetchStatus = 'idle', action: AnyAction) => {
    if (action.type === 'popup/popupRequested') return 'loading';
    if (action.type === 'popup/popupReceived') return 'succeeded';
    if (action.type === 'popup/popupRequestFailed') return 'failed';

    return state;
};

export const popupReducer = combineReducers({
    status,
    data,
});
